module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"collapsedTitle":"Arbeidshukommelse","collapsedSubtitle":"Test arbeidshukommelsen & lær en husketeknikk","collapsedButtonLabel":"Start","headerTitle":"Test arbeidshukommelsen"},"en":{"collapsedTitle":"Arbeidshukommelse","collapsedSubtitle":"Test arbeidshukommelsen & lær en husketeknikk","collapsedButtonLabel":"Start","headerTitle":"Test arbeidshukommelsen"}}')
  delete Component.options._Ctor
}
